<div class="menu">
    <span class="menu-heading">Choose a client</span>
    <span class="close" (click)="onCloseHandled()">X</span>
</div>

<div class="switch-client">
    <div *ngIf="accessibleClients?.length > 0">
        <select name="switch-client" class="switch-dropdown" [(ngModel)]="selectedClient.value"
          (change)="onSwitchClientChange()">
          <option label="Select..." value="-1" [selected]="selectedClient.value == '-1'"></option>
          <option [value]="client.abbreviation" *ngFor="let client of accessibleClients">
            {{client.abbreviation }}
          </option>
        </select>
        <!-- <select name="switch-client" [(ngModel)]="statusValue" (ngModelChange)="searchCases($event)"
          id="switch-client" style="background-color: #f8f9fb">
          <option *ngFor="let search of status" [ngValue]="search" [selected]="statusValue?.type == search.type">
            {{ search.label }}
          </option>
        </select> -->
      </div>
</div>
<div class="menu-bottom text-center bottom-border">
    <button type="button" [ngClass]="'done-btn-active'" (click)="onCloseHandled()">Cancel</button>
</div>